import { gql } from '@apollo/client';

const PARCEL_DETAIL_PAGE_BODY = `
      content {
        trackingNumber
        orderId
        overallStatus
        bagNumber
        taskNumber
        taskDate
        plannedDepartureTime
        actualDepartureTime
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
`;

// 仅用于本仓发出（OUTBOUND）视角，后端按 fromHubId 校验仓库权限
export const GET_INHUB_TRANSPORT_PARCEL_DETAIL_PAGE = gql`
  query GetInhubTransportParcelDetailPage($filter: InhubTransportDetailInput!) {
    getInhubTransportParcelDetailPage(filter: $filter) {
      ${PARCEL_DETAIL_PAGE_BODY}
    }
  }
`;

// 本仓到达（INBOUND）视角专用，后端按 toHubId 校验仓库权限
export const GET_INHUB_TRANSPORT_INBOUND_PARCEL_DETAIL_PAGE = gql`
  query GetInhubTransportInboundParcelDetailPage($filter: InhubTransportDetailInput!) {
    getInhubTransportInboundParcelDetailPage(filter: $filter) {
      ${PARCEL_DETAIL_PAGE_BODY}
    }
  }
`;

export interface InhubTransportParcelDetailRowResp {
    trackingNumber: string;
    orderId: number | null;
    overallStatus: string;
    bagNumber: string;
    taskNumber: string | null;
    taskDate: string | null;
    plannedDepartureTime: string | null;
    actualDepartureTime: string | null;
}

export interface InhubTransportParcelDetailPageResp {
    content: InhubTransportParcelDetailRowResp[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

// 两个视角各自独立的 operation，抽屉按当前视角二选一，故两个 key 均为可选
export interface GetInhubTransportParcelDetailPageResponse {
    getInhubTransportParcelDetailPage?: InhubTransportParcelDetailPageResp;
    getInhubTransportInboundParcelDetailPage?: InhubTransportParcelDetailPageResp;
}
